// var admobid = "test";

var admobid = {
  'android' : {
      'banner': "ca-app-pub-7938158814942247/3202223659",
      'interstitial': "ca-app-pub-7938158814942247/6316855040",
      'rewarded': "ca-app-pub-7938158814942247/6316855040",
      'rewardedInterstitial': ""
  }, 'ios' : {
      'banner': "ca-app-pub-7938158814942247/7906899238",
      'interstitial': "ca-app-pub-7938158814942247/7906899238",
      'rewarded': "ca-app-pub-7938158814942247/7906899238",
      'rewardedInterstitial': "ca-app-pub-7938158814942247/7906899238"
  }
};

var initAds = false;

var bannerPlacementId = "Banner_Android";
var InterstitialPlacementId = "Interstitial_Android";
var videoPlacementId = "Rewarded_Android";

//var unityGameID = "5215673";
var unityGameID = "6046606";

export async function initApp() {

  // NEW
  cordova.plugins.emiUnityAdsPlugin.unitySdkInitialize( unityGameID );



  /*
  document.addEventListener('onInitializationComplete', () => {

    alert("on Sdk Initialization Complete");
    cordova.plugins.emiUnityAdsPlugin.loadInterstitialAd( placementId = "Interstitial_Android" );
    document.addEventListener('onUnityAdsAdLoaded.Interstitial', () => {
      alert("showInterstitialAd Loaded");
      cordova.plugins.emiUnityAdsPlugin.showInterstitialAd();
    });
    document.addEventListener('onUnityAdsFailedToLoad.Interstitial', () => {
      alert("showInterstitialAd Failed");
    });

    
    setTimeout(() => {
        cordova.plugins.emiUnityAdsPlugin.hideBannerAd();
        cordova.plugins.emiUnityAdsPlugin.showInterstitialAd(InterstitialPlacementId);
            setTimeout(() => {
                cordova.plugins.emiUnityAdsPlugin.hideInterstitialAd();
                cordova.plugins.emiUnityAdsPlugin.showVideoAd(videoPlacementId);
            }, 5000);
    }, 5000);

  });*/


  /*
    if (!window.UnityAds) {
      alert("Unity Ads non disponibile");
      return;
    }

    UnityAds.init(6046606, false);
    alert("Unity Ads inizializzato");

    window.UnityBridge = {
        showAd: function (placement) {
            UnityAds.showVideoAd(
                placement,
                function () { alert("Ad pronto"); },
                function (err) { alert("Errore Unity:", err); }
            );
        }
    };*/



/*
  await adMob.banner(admobid).then(function () {
    // ads nel footer
  }).catch(function (err) {
    console.log("Errore 1");
    console.log(err);
  });

  await adMob.interstitial(admobid).then(function () {
    // ads fullscreen
    setTimeout(() => {
      return adMob.showInterstitial();
    }, 3000);
  }).then(function () {
  }).catch(function (err) {
    console.log("Errore 2");
    console.log(err);
  });*/

  initAds = true;
}

export async function InterstitialAd() {
  setTimeout(() => {
    cordova.plugins.emiUnityAdsPlugin.loadInterstitialAd( InterstitialPlacementId );
    document.addEventListener('onUnityAdsAdLoaded.Interstitial', () => {
      cordova.plugins.emiUnityAdsPlugin.showInterstitialAd();
    });
    }, 2000);
}

export async function rewardedAds() {
  if( initAds ) {
    await adMob.rewarded(admobid).then(function () {
      // if( localStorage.getItem("fm_user_id") && localStorage.getItem("fm_user_id") == 1 ) {
      //   alert("loaded rewarded ads");
      // }
      return adMob.showRewarded();
    }).then(function (reward) {
      // if( localStorage.getItem("fm_user_id") && localStorage.getItem("fm_user_id") == 1 ) {
      //   alert("showed rewarded ads" + JSON.stringify(reward));
      // }
    }).catch(function (err) {
      // if( localStorage.getItem("fm_user_id") && localStorage.getItem("fm_user_id") == 1 ) {
      //   alert("unable to load rewarded ads: " + JSON.stringify(err));
      // }
    });
  }

}

// if ((/(ipad|iphone|ipod|android|windows phone)/i.test(navigator.userAgent))) {
//   document.addEventListener('deviceready', initApp, false);
// } else {
//   initApp();
// }

export default { initApp, InterstitialAd };
